import {useEffect, useState} from "react";
import {Storage} from "aws-amplify";
import {useExtractedImagesState} from "./index";
import aws_config from '../modified_aws-export';
import {IExtractImageModel, IImageModel} from "../types/manualFinder";

export const useImageFetching = (extractedImages: Record<string, IImageModel>[]) => {
    const [parentImages, setParentImages] = useState<IExtractImageModel[]>([]);
    const {resetSelectedImages} = useExtractedImagesState();
    const [isLoadingImages, setIsLoadingImages] = useState(false);

    useEffect(() => {
        resetSelectedImages();
        const fetchImages = async () => {
            setIsLoadingImages(true);
            const getImage = async (key: string) => {
                Storage.configure({
                    aws_user_files_s3_bucket_region: aws_config.aws_user_files_s3_bucket_region,
                    aws_user_files_s3_bucket: aws_config.aws_user_files_s3_bucket,
                });
                return await Storage.get(`${key}`, {
                    level: "public",
                    customPrefix: {public: ""},
                    validateObjectExistence: true,
                });
            };

            const imageData = await Promise.all(
                extractedImages.map(async (element: Record<string, IImageModel>) => {
                    const keys = Object.keys(element);
                    const parentKey = keys[0];
                    const img = await getImage(parentKey);
                    const response = await fetch(img);
                    const blob = await response.blob();
                    const id = parentKey.split("/").pop()?.split(".")[0] || null;
                    const filename = `image_similarity_search/${id}.png`;
                    const newUploadFile = new File([blob], filename, {type: "image/png"});
                    const previewUrl = URL.createObjectURL(newUploadFile);

                    return {
                        parentImage: img,
                        parentFile: {
                            fileobject: newUploadFile,
                            preview: previewUrl,
                            id,
                        },
                        parentKeyName: parentKey,
                        matches: element[parentKey].matches,
                        isUseful: element[parentKey].is_useful,
                        feedbackProvided: element[parentKey].feedback_provided,
                    } as IExtractImageModel;
                })
            );

            setParentImages(imageData);
            setIsLoadingImages(false);
        };
        fetchImages().then();
    }, [extractedImages, resetSelectedImages]);

    return {parentImages, setParentImages, isLoadingImages};
};
